import React from "react";
import { Box, Container, Typography } from "@mui/material";
import styles from "./OpenAccount.module.css";
import Grid from '@mui/material/Grid2';

// Benefit Item Component
interface BenefitItemProps {
  number: string;
  title: string;
  description: string;
}

const BenefitItem: React.FC<BenefitItemProps> = ({ number, title, description }) => {
  return (
    <Grid size={{xs: 12, md: 4}} className={styles.benefitContainer}>
      <Box
                sx={{
                  width: {md: "48px", sm: "44px", xs: "44px"},
                  height: {md: "48px", sm: "44px", xs: "44px"},
                  bgcolor: "lime.100", 
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: {md: "0px", xs: "10px"},
                  padding: {md: "11px 0", xs: "10px"},
                }}
              >
                <Typography
                  variant="subtitle11"
                  sx={{
                    color: "darkPurple.500",
                  }}
                >
                  {number}
                </Typography>
              </Box>
      <article className={styles.benefitContent}>
        <h3 className={styles.benefitTitle} dangerouslySetInnerHTML={{ __html: title }}/>
        <p 
          className={styles.benefitDescription} 
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </article>
    </Grid>
  );
};

// Action Card Component
interface ActionCardProps {
  title: string;
  titleHighlight: string;
  description: string;
}

const ActionCard: React.FC<ActionCardProps> = ({ title, titleHighlight, description }) => {
  return (
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between", // This ensures title at top, description at bottom
        flex: "1 0 0",
        padding: {md: "48px", xs: "24px 20px"},
        gap: {xs: "32px"},
        alignSelf: "stretch",
        borderRadius: "12px",
        backgroundColor: "darkPurple.500",
        height: "100%", overflow: "hidden"
      }}>
        <Typography variant="subtitle13" sx={{color: "beige.100", width: "100%", textWrap: "nowrap"}}>
          <Box component="span" sx={{color: "lightPurple.400"}} >{titleHighlight}</Box>
          <Box component="span" dangerouslySetInnerHTML={{ __html: title }}/>
        </Typography>
        <Typography variant="body7" sx={{color: "darkPurple.100", width: "100%"}} dangerouslySetInnerHTML={{ __html: description }}/>
      </Box>
  );
};

// Main Component
const OpenAccount = () => {
  return (
    <>
      <Container className={styles.container} sx={{px: 1.5}}>
        {/* Header Section */}
        <header className={styles.header}>
          <h1 className={styles.title}>
            <span className={styles.titleDark}>OPEN YOUR</span> <br/>
            <span className={styles.titleHighlight}>EPAYR </span>
            <span className={styles.titleDark}>ACCOUNT</span>
          </h1>
          <p className={styles.subtitle}>
            MANAGE ALL YOUR FINANCIAL <br/> TRANSACTIONS EASILY
          </p>
        </header>

        {/* Features Section */}
        <section className={styles.featuresSection}>
          {/* Main Feature Card */}
          <article className={styles.mainFeatureCard}>
            <h2 className={styles.featureTitle}>DEDICATED IBAN ACCOUNT</h2>
            <Grid container spacing={2} className={styles.benefitsGrid}>
              <BenefitItem
                number="1"
                title="SEND MONEY <br/> TO FRIENDS AND FAMILY"
                description="TRANSFER FUNDS QUICKLY <br/>  ND SECURELY TO YOUR LOVED <br/>  ONES, ANYTIME, ANYWHERE"
              />
              <BenefitItem
                number="2"
                title="SPLIT GROUP <br/> PAYMENTS"
                description="SHARE EXPENSES WITHIN YOUR <br/> ACCOUNT—PERFECT FOR GROUP <br/> PURCHASES OR SHARED ACTIVITIES"
              />
              <BenefitItem
                number="3"
                title="MANAGE FREELANCE <br/> PAYMENTS"
                description="RECEIVE EARNINGS <br/> WITH EASE AND STAY IN FULL <br/> CONTROL OF YOUR FINANCES"
              />
            </Grid>
          </article>

          {/* Action Cards */}
      <Grid container spacing={1} sx={{
        display: "flex",
        alignItems: "flex-start",
        alignSelf: "stretch",
        flexDirection: {xs: "column", md: "row"}
      }}>
        <Grid size={{xs: 12, md: 6}} sx={{ display: "flex", height:"100%" }}>
            <ActionCard
            titleHighlight="TOP UP "
            title="BY SEPA,<br/>SWIFT OR CARD"
            description="RECEIVE PAYMENTS FROM <br/> ANYWHERE IN THE WORLD"
            />
        </Grid>
        <Grid size={{xs: 12, md: 6}} sx={{ display: "flex" }}>
            <ActionCard
            titleHighlight="WITHDRAW "
            title="USING SEPA,<br/>SWIFT OR CARD"
            description="SEND MONEY ACROSS <br/> THE GLOBE WITHOUT BORDERS"
            />
        </Grid>
        </Grid>
        </section>
      </Container>
    </>
  );
}

export default OpenAccount;
